"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var user_1 = require("adp-react-icons/lib/fa/user");
var _1 = require("../util/_");
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loadedUrl: undefined
        };
        _this.loadImage = function () {
            var url = _this.props.url;
            if (!url) {
                // prevent image from being set after is loaded
                _this.image = undefined;
                _this.setState({
                    loadedUrl: undefined
                });
                return;
            }
            var image = new Image();
            _this.image = image;
            image.onload = function () {
                if (image === _this.image) { // no other image was loaded after this one
                    _this.image = undefined;
                    _this.setState({
                        loadedUrl: url
                    });
                }
            };
            image.onerror = function () {
                if (image === _this.image) { // no other image was loaded after this one
                    _this.image = undefined;
                    _this.setState({
                        loadedUrl: undefined
                    });
                }
            };
            image.src = url;
        };
        return _this;
    }
    Avatar.prototype.componentDidMount = function () {
        this.loadImage();
    };
    Avatar.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.url !== nextProps.url) {
            this.setState({
                loadedUrl: undefined
            }, this.loadImage);
        }
    };
    Avatar.prototype.componentWillUnmount = function () {
        this.image = undefined;
    };
    Avatar.prototype.render = function () {
        var _a = this.props, size = _a.size, className = _a.className, initials = _a.initials, style = _a.style;
        var avatarStyle = Object.assign({}, style);
        var customProps = _1.omit(this.props, Object.keys(Avatar.propTypes));
        var showInitials = false;
        var avatarClasses = [
            vdl_prefix_1.vdlPrefix('avatar'),
            vdl_prefix_1.vdlPrefix("avatar--" + size)
        ];
        if (this.state.loadedUrl) {
            avatarStyle['backgroundImage'] = "url(" + this.state.loadedUrl + ")";
        }
        else if (typeof this.props.initials !== 'undefined') {
            showInitials = true;
            avatarStyle['backgroundImage'] = 'none';
        }
        var showUserIcon = !this.state.loadedUrl && !showInitials;
        return (React.createElement("div", __assign({}, customProps, { className: classnames_1.classNames(className, avatarClasses), style: avatarStyle }),
            React.createElement("div", { className: vdl_prefix_1.vdlPrefix('avatar__container') },
                showUserIcon && React.createElement(user_1.default, { className: vdl_prefix_1.vdlPrefix('avatar__icon') }),
                showInitials &&
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('avatar__initials') }, initials))));
    };
    Avatar.propTypes = {
        size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
        url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        initials: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        className: PropTypes.string,
        style: PropTypes.object
    };
    Avatar.defaultProps = {
        size: 'sm'
    };
    return Avatar;
}(React.PureComponent));
exports.Avatar = Avatar;
